import React, { useState, useEffect } from 'react';
import RootErrorPage, { RootErrorPageShape } from './RootErrorPage';

function DelayedErrorPage(errorProps: RootErrorPageShape) {
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDisplay(true), 4000);
    return () => {
      clearInterval(timer);
      setDisplay(false);
    };
  }, []);

  return display ? <RootErrorPage {...errorProps} /> : <></>;
}

export default DelayedErrorPage;
